import { useCallback } from 'react';
import { EXT_MANAGER_KEY, MESSAGE_TYPES, TRANSIT_MESSAGE_KEYS } from 'cfg/endpoints';

export const useMessageToTop = () => {
    const sendMessageToTop = useCallback((message: any) => {
        if (window.top && document.location.ancestorOrigins 
            && document.location.ancestorOrigins.length > 0) {
            const ancestorOrigin = document.location.ancestorOrigins[0];
            try { 
                window.top.postMessage(message, ancestorOrigin); 
            } catch (e) {
                console.error('Error sending message to top:', e);
            }
        }
    }, []);

    const passMessageToWeb = useCallback((target_manager: string, message_info: any) => {
        sendMessageToTop({
            type: MESSAGE_TYPES.TRELLUS_ROUTER_PASSING, 
            [TRANSIT_MESSAGE_KEYS.SOURCE_INFO]: { [EXT_MANAGER_KEY.MANAGER_TYPE]: 'EXTERNAL'}, 
            [TRANSIT_MESSAGE_KEYS.TARGET_INFO]: { [EXT_MANAGER_KEY.MANAGER_TYPE]: target_manager}, 
            [TRANSIT_MESSAGE_KEYS.MESSAGE_INFO]: message_info
        });
    }, [sendMessageToTop]);

    return {
        sendMessageToTop,
        passMessageToWeb
    };
}; 